import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { LoadingComponent } from '@cue/loading';
import { DateFormatPipe } from '@cue/pipes';
import { ImageWidthPipe, LocalizedStringPipe } from '@cue/utilities';
import { LayoutTitleComponent } from '@assist/ui/layout-title';
import { NewsItemBM } from '@cue/api';

@Component({
  selector: 'assist-multiview-news',
  imports: [LoadingComponent, DateFormatPipe, ImageWidthPipe, LayoutTitleComponent, LocalizedStringPipe],
  templateUrl: './multiview-news.component.html',
  styleUrl: './multiview-news.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultiviewNewsComponent {
  ICONS = {};
  news = input.required<NewsItemBM>();
  loading = input.required<boolean>();
}
